import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/pencil-square-active.svg'


const _withScopeId = n => (_pushScopeId("data-v-219f0566"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex flex-wrap mb-4 mb-lg-5 justify-content-center align-items-center" }
const _hoisted_2 = { class: "d-flex mb-lg-0 px-lg-5 mt-3 mt-lg-0 justify-content-around order-1" }
const _hoisted_3 = { class: "icon-box position-relative mb-2" }
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = ["src", "alt"]
const _hoisted_7 = { class: "text text-center fw-bold fs-6" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "caret text-center position-absolute" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-caret-down" })
], -1))
const _hoisted_9 = {
  class: "order-2 w-100 mt-3",
  id: "profile-mobile"
}
const _hoisted_10 = {
  key: 0,
  class: "bg-white shadow rounded-4 my-3 p-4"
}
const _hoisted_11 = { class: "user-container d-flex" }
const _hoisted_12 = ["src"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "edit-profile-icon-area" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1))
const _hoisted_14 = {
  key: 0,
  class: "flex-grow-1 d-flex justify-content-center flex-column"
}
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { class: "fw-bold fs-9 text-break" }
const _hoisted_17 = { class: "fw-bold fs-9 text-break" }
const _hoisted_18 = { class: "fs-7 text-break" }
const _hoisted_19 = {
  key: 0,
  class: "d-flex order-3 w-100"
}
const _hoisted_20 = { class: "d-flex align-items-center mx-2 mt-2" }

import { NAVES } from '@/constants/index'
import { translate } from '@/languages/i18n'
import Button from '@/components/button/index.vue'
import { useRoute, useRouter } from 'vue-router'
import Search from '@/components/search-input/index.vue'
import { omit, difference } from 'lodash'
import { CommunityStateTypes } from '@/store/modules/community'
import { useStore } from 'vuex'
import { COMMUNITY_STORE, ROOT_STORE } from '@/store/constants'
import { computed, ComputedRef } from 'vue'
import { addUserIconParams, userType } from '@/use/usePath'
import { isSaasTypePool } from '@/utils'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute()
const router = useRouter()
const store = useStore()

const me = computed<ComputedRef<Pick<CommunityStateTypes, 'me'>>>(() => store.getters[COMMUNITY_STORE.GETTERS.GET_ME])
const profileCommunity = computed<CommunityStateTypes>(() => store.getters[COMMUNITY_STORE.GETTERS.COMMUNITY_INFO])
const isPhone = computed<boolean>(() => store.getters[ROOT_STORE.GETTERS.CHECK_PHONE_DEVICE])

const buildUrl = (query): string => {
  let url = route.path
  let queryParams = { ...omit(route.query, 'content_type', 'my_post', 'favorite'), ...query }
  Object.keys(queryParams).forEach((e, i) => {
    url += `${i == 0 ? '?' : '&'}${e}=${encodeURIComponent(queryParams[e])}`
  })
  return url
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("ul", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(NAVES), (nav, index) => {
        return (_openBlock(), _createElementBlock(_Fragment, {
          key: nav.id
        }, [
          (nav.id !== 6 || (nav.id == 6 && !_unref(isSaasTypePool)(_unref(profileCommunity).saas_type)))
            ? (_openBlock(), _createElementBlock("li", {
                key: 0,
                class: _normalizeClass([
            'position-relative w-100 cursor-pointer',
            _unref(route)?.query[Object.keys(nav.query)[0]] === '' + nav.query[Object.keys(nav.query)[0]] ||
            (_unref(difference)(['content_type', 'favorite', 'my_post'], Object.keys(_unref(route).query)).length === 3 && index === 0)
              ? 'active'
              : '',
            _unref(me)?.employee_user_id && index === 3 ? 'd-none' : '',
          ])
              }, [
                _createVNode(_component_router_link, {
                  to: buildUrl(nav.query),
                  class: "text-decoration-none text-black w-100 d-block",
                  exact: ""
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_3, [
                      _createElementVNode("img", {
                        src: nav.icon,
                        class: "icon",
                        alt: `icon-${index}`
                      }, null, 8, _hoisted_4),
                      _createElementVNode("img", {
                        src: nav.iconHover,
                        class: "icon icon--hover",
                        alt: `icon-hover-${index}`
                      }, null, 8, _hoisted_5),
                      _createElementVNode("img", {
                        src: nav.iconActive,
                        class: "icon icon--active",
                        alt: `icon-active-${index}`
                      }, null, 8, _hoisted_6)
                    ]),
                    _createElementVNode("div", _hoisted_7, _toDisplayString(nav.title), 1),
                    _hoisted_8
                  ]),
                  _: 2
                }, 1032, ["to"])
              ], 2))
            : _createCommentVNode("", true)
        ], 64))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_9, [
      (_unref(route).path === `/${_unref(route).path.split('/')[1]}/communities/${_unref(route)?.params?.id}`)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_router_link, {
                to: `/${_unref(route).path.split('/')[1]}/communities/${_unref(router).currentRoute.value.params.id}/account/profile/setting`,
                class: "me-4 position-relative"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("img", {
                    src: _unref(me)?.profile?.image_url ? _unref(addUserIconParams)(_unref(me)?.profile?.image_url, _unref(userType)()) : require('@/assets/images/user-empty.svg'),
                    alt: "user"
                  }, null, 8, _hoisted_12),
                  _hoisted_13
                ]),
                _: 1
              }, 8, ["to"]),
              (_unref(me))
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    (_unref(me).employee_user_id)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                          _createElementVNode("h2", _hoisted_16, _toDisplayString(_unref(me).profile?.display_name), 1)
                        ]))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createElementVNode("h2", _hoisted_17, _toDisplayString(_unref(me).profile?.family_name) + " " + _toDisplayString(_unref(me).profile?.given_name), 1),
                          _createElementVNode("h4", _hoisted_18, _toDisplayString(_unref(me).profile?.display_name), 1)
                        ], 64))
                  ]))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    (_unref(isPhone))
      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
          ((_unref(profileCommunity).post_article_permission || _unref(profileCommunity).post_recruitment_permission) && !_unref(isSaasTypePool)(_unref(profileCommunity).saas_type))
            ? (_openBlock(), _createBlock(Button, {
                key: 0,
                title: _unref(translate)('postArticle'),
                class: "fw-bold mt-2 mt-lg-0 flex-grow-1",
                dataBsToggle: "modal",
                dataBsTarget: "#createPost"
              }, null, 8, ["title"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_20, [
            _createVNode(Search, { keyword: 'keyword' })
          ])
        ]))
      : _createCommentVNode("", true),
    (!_unref(isPhone) && (_unref(profileCommunity).post_article_permission || _unref(profileCommunity).post_recruitment_permission) && !_unref(isSaasTypePool)(_unref(profileCommunity).saas_type))
      ? (_openBlock(), _createBlock(Button, {
          key: 1,
          title: _unref(translate)('postArticle'),
          class: "fw-bold order-4 order-lg-3 mt-4 mt-lg-0 m-w-unset btn-mobile",
          dataBsToggle: "modal",
          dataBsTarget: "#createPost"
        }, null, 8, ["title"]))
      : _createCommentVNode("", true),
    (!_unref(isPhone))
      ? (_openBlock(), _createBlock(Search, {
          key: 2,
          keyword: 'keyword',
          class: "order-3 order-lg-4"
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})